import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userRoleEmployerName'
})
export class UserRoleEmployerNamePipe implements PipeTransform {

  transform(value: string): string {

    let role: string = '';

    switch (value) {
      case 'recruiter':
        role = 'Reclutador';
        break;

      case 'psychologist':
        role = 'Psicólogo';
        break;

      case 'view':
        role = 'Solo lectura';
        break;

      case 'admin':
        role = 'Administrador';
        break;

    }
    return role;
  }
}
